import Head from 'next/head';
import { useRouter } from 'next/router';
import { DEFAULT_LOCALE, PUBLIC_HOST } from '@config/index';

type PropsType = {
  currentUrl?: string;
};

/**
 * W Next.js i18n router.asPath to ścieżka tak jak w przeglądarce:
 * - lokalnie (dev) zwykle bez prefiksu locale (pathname: /product/...),
 * - na produkcji często z prefiksem (pathname: /en/product/...).
 * Usuwamy prefix tylko gdy pierwszy segment to bieżący locale, żeby canonical
 * nie dublował segmentu (np. /en/en/product/...) — bez polegania na router.locales.
 */
function getPathWithoutLocale(pathname: string, currentLocale: string): string {
  const segment = pathname.replace(/^\//, '').split('/')[0];
  if (segment === currentLocale) {
    return pathname.slice(segment.length + 1) || '/';
  }
  return pathname;
}

const SelfCanonicalLink = ({ currentUrl = undefined }: PropsType) => {
  const { locale, asPath } = useRouter();
  const url = new URL(asPath, PUBLIC_HOST);
  const pathWithoutQuery = getPathWithoutLocale(url.pathname, locale ?? '');
  const path =
    currentUrl ?? `${PUBLIC_HOST}${locale !== DEFAULT_LOCALE ? `/${locale}${pathWithoutQuery}` : pathWithoutQuery}`;

  return (
    <Head>
      <link rel="canonical" href={path} />
    </Head>
  );
};

export default SelfCanonicalLink;
